"use strict";

var _regeneratorRuntime = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _ImageDrawer_images;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDrawer = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var Utils_2 = require("./Utils");

var ImageDrawer =
/*#__PURE__*/
function () {
  function ImageDrawer() {
    _classCallCheck(this, ImageDrawer);

    _ImageDrawer_images.set(this, void 0);

    __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
  }

  _createClass(ImageDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "getImages",
    value: function getImages(container) {
      var containerImages = __classPrivateFieldGet(this, _ImageDrawer_images, "f").find(function (t) {
        return t.id === container.id;
      });

      if (!containerImages) {
        __classPrivateFieldGet(this, _ImageDrawer_images, "f").push({
          id: container.id,
          images: []
        });

        return this.getImages(container);
      } else {
        return containerImages;
      }
    }
  }, {
    key: "addImage",
    value: function addImage(container, image) {
      var containerImages = this.getImages(container);
      containerImages === null || containerImages === void 0 ? void 0 : containerImages.images.push(image);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(container) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, manualParticle, emitterOptions, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, emitter, interactiveEmitters, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _emitter;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadImagesFromParticlesOptions(container, container.actualOptions.particles);

              case 2:
                _context.next = 4;
                return this.loadImagesFromParticlesOptions(container, container.actualOptions.interactivity.modes.trail.particles);

              case 4:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = container.actualOptions.manualParticles[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 16;
                  break;
                }

                manualParticle = _step.value;
                _context.next = 13;
                return this.loadImagesFromParticlesOptions(container, manualParticle.options);

              case 13:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 22:
                _context.prev = 22;
                _context.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 25:
                _context.prev = 25;

                if (!_didIteratorError) {
                  _context.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context.finish(25);

              case 29:
                return _context.finish(22);

              case 30:
                emitterOptions = container.actualOptions;

                if (!emitterOptions.emitters) {
                  _context.next = 63;
                  break;
                }

                if (!(emitterOptions.emitters instanceof Array)) {
                  _context.next = 61;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 36;
                _iterator2 = emitterOptions.emitters[Symbol.iterator]();

              case 38:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 45;
                  break;
                }

                emitter = _step2.value;
                _context.next = 42;
                return this.loadImagesFromParticlesOptions(container, emitter.particles);

              case 42:
                _iteratorNormalCompletion2 = true;
                _context.next = 38;
                break;

              case 45:
                _context.next = 51;
                break;

              case 47:
                _context.prev = 47;
                _context.t1 = _context["catch"](36);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 51:
                _context.prev = 51;
                _context.prev = 52;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 54:
                _context.prev = 54;

                if (!_didIteratorError2) {
                  _context.next = 57;
                  break;
                }

                throw _iteratorError2;

              case 57:
                return _context.finish(54);

              case 58:
                return _context.finish(51);

              case 59:
                _context.next = 63;
                break;

              case 61:
                _context.next = 63;
                return this.loadImagesFromParticlesOptions(container, emitterOptions.emitters.particles);

              case 63:
                interactiveEmitters = emitterOptions.interactivity.modes.emitters;

                if (!interactiveEmitters) {
                  _context.next = 96;
                  break;
                }

                if (!(interactiveEmitters instanceof Array)) {
                  _context.next = 94;
                  break;
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 69;
                _iterator3 = interactiveEmitters[Symbol.iterator]();

              case 71:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context.next = 78;
                  break;
                }

                _emitter = _step3.value;
                _context.next = 75;
                return this.loadImagesFromParticlesOptions(container, _emitter.particles);

              case 75:
                _iteratorNormalCompletion3 = true;
                _context.next = 71;
                break;

              case 78:
                _context.next = 84;
                break;

              case 80:
                _context.prev = 80;
                _context.t2 = _context["catch"](69);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t2;

              case 84:
                _context.prev = 84;
                _context.prev = 85;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 87:
                _context.prev = 87;

                if (!_didIteratorError3) {
                  _context.next = 90;
                  break;
                }

                throw _iteratorError3;

              case 90:
                return _context.finish(87);

              case 91:
                return _context.finish(84);

              case 92:
                _context.next = 96;
                break;

              case 94:
                _context.next = 96;
                return this.loadImagesFromParticlesOptions(container, interactiveEmitters.particles);

              case 96:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 18, 22, 30], [23,, 25, 29], [36, 47, 51, 59], [52,, 54, 58], [69, 80, 84, 92], [85,, 87, 91]]);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
    }
  }, {
    key: "loadImagesFromParticlesOptions",
    value: function () {
      var _loadImagesFromParticlesOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(container, options) {
        var _a, _b, _c, shapeOptions, idx, imageOptions, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, optionsImage, groupName, group;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                shapeOptions = options === null || options === void 0 ? void 0 : options.shape;

                if (!(!(shapeOptions === null || shapeOptions === void 0 ? void 0 : shapeOptions.type) || !shapeOptions.options || !(0, Utils_1.isInArray)(Enums_1.ShapeType.image, shapeOptions.type) && !(0, Utils_1.isInArray)(Enums_1.ShapeType.images, shapeOptions.type))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                idx = __classPrivateFieldGet(this, _ImageDrawer_images, "f").findIndex(function (t) {
                  return t.id === container.id;
                });

                if (idx >= 0) {
                  __classPrivateFieldGet(this, _ImageDrawer_images, "f").splice(idx, 1);
                }

                imageOptions = (_a = shapeOptions.options[Enums_1.ShapeType.images]) !== null && _a !== void 0 ? _a : shapeOptions.options[Enums_1.ShapeType.image];

                if (!(imageOptions instanceof Array)) {
                  _context2.next = 35;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context2.prev = 10;
                _iterator4 = imageOptions[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context2.next = 19;
                  break;
                }

                optionsImage = _step4.value;
                _context2.next = 16;
                return this.loadImageShape(container, optionsImage);

              case 16:
                _iteratorNormalCompletion4 = true;
                _context2.next = 12;
                break;

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](10);
                _didIteratorError4 = true;
                _iteratorError4 = _context2.t0;

              case 25:
                _context2.prev = 25;
                _context2.prev = 26;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 28:
                _context2.prev = 28;

                if (!_didIteratorError4) {
                  _context2.next = 31;
                  break;
                }

                throw _iteratorError4;

              case 31:
                return _context2.finish(28);

              case 32:
                return _context2.finish(25);

              case 33:
                _context2.next = 37;
                break;

              case 35:
                _context2.next = 37;
                return this.loadImageShape(container, imageOptions);

              case 37:
                if (!(options === null || options === void 0 ? void 0 : options.groups)) {
                  _context2.next = 46;
                  break;
                }

                _context2.t1 = _regeneratorRuntime.keys(options.groups);

              case 39:
                if ((_context2.t2 = _context2.t1()).done) {
                  _context2.next = 46;
                  break;
                }

                groupName = _context2.t2.value;
                group = options.groups[groupName];
                _context2.next = 44;
                return this.loadImagesFromParticlesOptions(container, group);

              case 44:
                _context2.next = 39;
                break;

              case 46:
                if (!((_c = (_b = options === null || options === void 0 ? void 0 : options.destroy) === null || _b === void 0 ? void 0 : _b.split) === null || _c === void 0 ? void 0 : _c.particles)) {
                  _context2.next = 49;
                  break;
                }

                _context2.next = 49;
                return this.loadImagesFromParticlesOptions(container, options === null || options === void 0 ? void 0 : options.destroy.split.particles);

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 21, 25, 33], [26,, 28, 32]]);
      }));

      function loadImagesFromParticlesOptions(_x2, _x3) {
        return _loadImagesFromParticlesOptions.apply(this, arguments);
      }

      return loadImagesFromParticlesOptions;
    }()
  }, {
    key: "loadImageShape",
    value: function () {
      var _loadImageShape = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(container, imageShape) {
        var imageFunc, image;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                imageFunc = imageShape.replaceColor ? Utils_2.downloadSvgImage : Utils_2.loadImage;
                _context3.next = 4;
                return imageFunc(imageShape.src);

              case 4:
                image = _context3.sent;

                if (image) {
                  this.addImage(container, image);
                }

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.warn("tsParticles error - ".concat(imageShape.src, " not found"));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function loadImageShape(_x4, _x5) {
        return _loadImageShape.apply(this, arguments);
      }

      return loadImageShape;
    }()
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b;

      if (!context) {
        return;
      }

      var image = particle.image;
      var element = (_a = image === null || image === void 0 ? void 0 : image.data) === null || _a === void 0 ? void 0 : _a.element;

      if (!element) {
        return;
      }

      var ratio = (_b = image === null || image === void 0 ? void 0 : image.ratio) !== null && _b !== void 0 ? _b : 1;
      var pos = {
        x: -radius,
        y: -radius
      };

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = opacity;
      }

      context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = 1;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(particle) {
      var _a, _b, _c, _d, _e, _f, _g;

      if (particle.shape !== "image" && particle.shape !== "images") {
        return;
      }

      var images = this.getImages(particle.container).images;
      var imageData = particle.shapeData;
      var image = (_a = images.find(function (t) {
        return t.source === imageData.src;
      })) !== null && _a !== void 0 ? _a : images[0];
      var color = particle.getFillColor();
      var imageRes;

      if (!image) {
        return;
      }

      if (image.svgData !== undefined && imageData.replaceColor && color) {
        var svgColoredData = (0, Utils_2.replaceColorSvg)(image, color, (_c = (_b = particle.opacity) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 1);
        var svg = new Blob([svgColoredData], {
          type: "image/svg+xml"
        });
        var domUrl = URL || window.URL || window.webkitURL || window;
        var url = domUrl.createObjectURL(svg);
        var img = new Image();
        imageRes = {
          data: Object.assign(Object.assign({}, image), {
            svgData: svgColoredData
          }),
          ratio: imageData.width / imageData.height,
          replaceColor: (_d = imageData.replaceColor) !== null && _d !== void 0 ? _d : imageData.replace_color,
          source: imageData.src
        };
        img.addEventListener("load", function () {
          var pImage = particle.image;

          if (pImage) {
            pImage.loaded = true;
            image.element = img;
          }

          domUrl.revokeObjectURL(url);
        });
        img.addEventListener("error", function () {
          domUrl.revokeObjectURL(url);
          (0, Utils_2.loadImage)(imageData.src).then(function (img2) {
            var pImage = particle.image;

            if (pImage) {
              image.element = img2 === null || img2 === void 0 ? void 0 : img2.element;
              pImage.loaded = true;
            }
          });
        });
        img.src = url;
      } else {
        imageRes = {
          data: image,
          loaded: true,
          ratio: imageData.width / imageData.height,
          replaceColor: (_e = imageData.replaceColor) !== null && _e !== void 0 ? _e : imageData.replace_color,
          source: imageData.src
        };
      }

      if (!imageRes.ratio) {
        imageRes.ratio = 1;
      }

      var fill = (_f = imageData.fill) !== null && _f !== void 0 ? _f : particle.fill;
      var close = (_g = imageData.close) !== null && _g !== void 0 ? _g : particle.close;
      var imageShape = {
        image: imageRes,
        fill: fill,
        close: close
      };
      particle.image = imageShape.image;
      particle.fill = imageShape.fill;
      particle.close = imageShape.close;
    }
  }]);

  return ImageDrawer;
}();

exports.ImageDrawer = ImageDrawer;
_ImageDrawer_images = new WeakMap();